import { DriverActionTypes, ILoginRequiredState } from "../../store/mobile/types";
import { MobileActions } from "../../store/mobile/actions";
import { DataActions } from "../../store/data/actions";
import { handleJSNative } from "../error";
import * as logger from "../logger";

export function handleUserActions() {
    window.webViewLayer.driverActionNecessary = function (isDriverActionNecessary: boolean, driverActionType: DriverActionTypes) {
        try {
            window.geotabModules?.user.driverActionNecessary({ isDriverActionNecessary, driverActionType }, () => { });
        } catch (error) {
            handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
        }
    };

    window.webViewLayer.clearLoginWorkflowState = function () {
        const app = window.driveApp;
        app.store.dispatch(MobileActions.setDriverActionNecessary({
            isNecessary: false,
            actionType: DriverActionTypes.Workflow
        }));
        const currentUser = app.userService.getCurrentUser();
        currentUser && app.store.dispatch(DataActions.clearTempAssets(currentUser.id));
    };

    window.webViewLayer.pageNavigation = function (path: string) {
        try {
            window.geotabModules?.user.pageNavigation(path, () => { });
        } catch (error) {
            handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
        }
    };

    window.webViewLayer.loginRequired = function (state: ILoginRequiredState) {
        try {
            logger.event(logger.Event.DEBUG_LOGINVIEW_NAVIGATE, `loginRequired event triggered`);
            window.geotabModules?.user.loginRequired(state, () => undefined);
        } catch (error) {
            handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
        }
    };

    window.webViewLayer.syncActiveUsers = function (activeUsers: string[]) {
        try {
            window.geotabModules?.user.syncActiveUsers?.({ activeUsers }, () => { });
        } catch (error) {
            handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
        }
    };

    window.webViewLayer.sessionEstablished = function (arg) {
        try {
            window.geotabModules?.user.sessionEstablished?.(arg, () => { });
        } catch (error) {
            handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
        }
    };
}
